import React, { useState, useCallback } from "react";


// Notification context
const NotificationContext = React.createContext();

// Notification provider
export const NotificationProvider = ({ children }) => {

    const [notifications, setNotifications] = useState([]);

    const addNotification = (notification) => {
        setNotifications([...notifications, notification]);
    };

    const AddNoti = useCallback((msg, msg2, type) => {

        let kind = ""; //    1: success    2: error   3: warning

        if (msg == null || msg === "") {
            msg = msg2;
        }

        if (type === 1) {
            kind = "success";
        } else if (type === 2) {
            kind = "danger";
        } else if (type === 3) {
            kind = "warning";
        }

        let notification = {
            id: Date.now(),
            message: msg,
            kind: kind,
        };

        //setNotifications([...notifications, notification]);

        setNotifications(prev => [...prev, notification]); // Recomendado por mi amiguito GPT

    }, []);

    const removeNotification = (id) => {
        setNotifications(notifications.filter((notif) => notif.id !== id));
    };

    return (
        <NotificationContext.Provider
            value={{ notifications, addNotification, removeNotification, AddNoti }}
        >
            {children}
        </NotificationContext.Provider>
    );
};

// Custom hook to use notifications
export const useNotifications = () => {
    const context = React.useContext(NotificationContext);
    if (!context) {
        throw new Error(
            "useNotifications must be used within a NotificationProvider"
        );
    }
    return context;
};
